import React, { PropTypes } from 'react';
import SecondaryMenuLink from './SecondaryMenuLink';

const SecondaryMenu = ({ lang, menu, edition }) => (
  <nav className="c-website-menu__item website-menu--secondary">
    <ul className="c-website-menu__list website-menu--secondary__list">
      <SecondaryMenuLink lang={lang} key="about" item="about" edition={edition} />
      <SecondaryMenuLink lang={lang} key="projects" item="projects" menu={menu} edition={edition} />
      <SecondaryMenuLink lang={lang} key="support" item="support" edition={edition} />
      <SecondaryMenuLink lang={lang} key="contact" item="contact" edition={edition} />
    </ul>
  </nav>
);

export default SecondaryMenu;

SecondaryMenu.propTypes = {
  edition: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./js/components/menus/SecondaryMenu.js